<template>
    <div>
        <div class="row">
            <div class="col-xxl-6 px-1 px-md-3 mb-3">
                <!--begin::Tiles Widget 12-->
                <div class="card card-custom"
                     style="height: 150px;background-image: url(https://img.freepik.com/free-vector/mobile-marketing-concept-illustration_114360-1497.jpg?t=st=1658725589~exp=1658726189~hmac=a23a059b3afbbf13d40138ad35dba153d830fa70c0e89fe2de9fa5f04c623ccf&w=740);background-position: center;background-size: contain">
                    <div class="card-body">
                        <div class="text-dark font-weight-bolder font-size-h2 mt-3">
                        </div>
                    </div>
                </div>
                <!--end::Tiles Widget 12-->
            </div>
            <div class="col-xxl-6 px-1 px-md-3 mb-3">
                <!--begin::Tiles Widget 12-->
                <div class="card ribbon card-custom"
                     style="height: 150px;background-image: url(https://img.freepik.com/free-vector/tiny-people-marketing-manager-with-megaphone-push-advertising-push-advertising-traditional-marketing-strategy-interruption-marketing-concept-illustration_335657-2571.jpg?t=st=1658725589~exp=1658726189~hmac=78c39344073bf823c636fd9dc208e9563644a9e7a5832e95bb46a2684bdb31bd&w=900);background-size: contain;background-position: center">
                    <span class="text-white py-4 font-weight-bolder mt-3"></span>
                    <div class="card-body">
                        <div class="text-dark font-weight-bolder font-size-h2 mt-3">
                        </div>
                    </div>
                </div>
                <!--end::Tiles Widget 12-->
            </div>
        </div>
        <div class="row">
            <div class="col-xxl-6 px-1 px-md-3 mb-3">
                <!--begin::Tiles Widget 12-->
                <div class="card card-custom"
                     style="height: 150px;background-image: url(https://img.freepik.com/free-vector/remarketing-manager-specialist-put-targeted-ads-remarketing-strategy-digital-marketing-tool-visitors-generation-methodology-concept-pinkish-coral-bluevector-isolated-illustration_335657-2284.jpg?t=st=1658720624~exp=1658721224~hmac=e0bc18bd0332a28a069a1da243cb0394255ba854d8bcd7729472270ca62c6a2c&w=900);background-position: center;background-size: contain">
                    <div class="card-body">
                        <div class="text-dark font-weight-bolder font-size-h2 mt-3">
                        </div>
                    </div>
                </div>
                <!--end::Tiles Widget 12-->
            </div>
            <div class="col-xxl-6 px-1 px-md-3 mb-3">
                <!--begin::Tiles Widget 12-->
                <div class="card ribbon card-custom"
                     style="height: 150px;background-image: url(https://img.freepik.com/free-vector/social-strategy-concept-illustration_114360-724.jpg?t=st=1658693852~exp=1658694452~hmac=3d67c7ef7700f79eb5357f6a564f10442aa63a1de1f31658c37906a1dc1e5013&w=900);background-size: contain;background-position: center">
                    <span class="text-white py-4 font-weight-bolder mt-3"></span>
                    <div class="card-body">
                        <div class="text-dark font-weight-bolder font-size-h2 mt-3">
                        </div>
                    </div>
                </div>
                <!--end::Tiles Widget 12-->
            </div>
        </div>

        <!--    &lt;!&ndash;begin::Header&ndash;&gt;-->
        <!--    <div class="card-header border-0 py-5">-->
        <!--      <h3 class="card-title align-items-start flex-column">-->
        <!--        <span class="card-label font-weight-bolder text-dark">-->
        <!--          دفترچه یادداشت-->
        <!--        </span>-->
        <!--      </h3>-->
        <!--      <div class="card-toolbar">-->
        <!--        <a href="#" class="btn btn-success font-weight-bolder font-size-sm">-->
        <!--          <span class="svg-icon svg-icon-md svg-icon-white">-->
        <!--            <i class="fa fa-plus"></i></span>ایجاد یادداشت جدید</a-->
        <!--        >-->
        <!--      </div>-->
        <!--    </div>-->
        <!--    &lt;!&ndash;end::Header&ndash;&gt;-->
        <!--    &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--    <div class="card-body py-0">-->
        <!--      &lt;!&ndash;begin::Table&ndash;&gt;-->
        <!--      <div class="table-responsive">-->
        <!--        <table-->
        <!--            class="table table-head-custom table-vertical-center"-->
        <!--            id="kt_advance_table_widget_1"-->
        <!--        >-->
        <!--          <thead>-->
        <!--          <tr class="text-left">-->
        <!--            <th class="pl-0" style="width: 20px">-->
        <!--              <label class="checkbox checkbox-lg checkbox-single">-->
        <!--                <input-->
        <!--                    type="checkbox"-->
        <!--                    @input="setCheck($event.target.checked)"-->
        <!--                />-->
        <!--                <span></span>-->
        <!--              </label>-->
        <!--            </th>-->
        <!--            <th class="pr-0" style="width: 50px">authors</th>-->
        <!--            <th style="min-width: 200px"></th>-->
        <!--            <th style="min-width: 150px">company</th>-->
        <!--            <th style="min-width: 150px">progress</th>-->
        <!--            <th class="pr-0 text-right" style="min-width: 150px">action</th>-->
        <!--          </tr>-->
        <!--          </thead>-->
        <!--          <tbody>-->
        <!--          <template v-for="(item, i) in list">-->
        <!--            <tr v-bind:key="i">-->
        <!--              <td class="pl-0">-->
        <!--                <label class="checkbox checkbox-lg checkbox-single">-->
        <!--                  <input type="checkbox" value="1" :checked="checked"/>-->
        <!--                  <span></span>-->
        <!--                </label>-->
        <!--              </td>-->
        <!--              <td class="pr-0">-->
        <!--                <div class="symbol symbol-50 symbol-light mt-1">-->
        <!--                    <span class="symbol-label">-->
        <!--                      <img-->
        <!--                          :src="item.text0"-->
        <!--                          class="h-75 align-self-end"-->
        <!--                          alt=""-->
        <!--                      />-->
        <!--                    </span>-->
        <!--                </div>-->
        <!--              </td>-->
        <!--              <td class="pl-0">-->
        <!--                <a-->
        <!--                    href="#"-->
        <!--                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"-->
        <!--                >{{ item.text1 }}</a-->
        <!--                >-->
        <!--                <span-->
        <!--                    class="text-muted font-weight-bold text-muted d-block"-->
        <!--                >{{ item.text2 }}</span-->
        <!--                >-->
        <!--              </td>-->
        <!--              <td>-->
        <!--                  <span-->
        <!--                      class="text-dark-75 font-weight-bolder d-block font-size-lg"-->
        <!--                  >{{ item.text3 }}</span-->
        <!--                  >-->
        <!--                <span class="text-muted font-weight-bold">{{-->
        <!--                    item.text4-->
        <!--                  }}</span>-->
        <!--              </td>-->
        <!--              <td>-->
        <!--                <div class="d-flex flex-column w-100 mr-2">-->
        <!--                  <div-->
        <!--                      class="d-flex align-items-center justify-content-between mb-2"-->
        <!--                  >-->
        <!--                      <span-->
        <!--                          class="text-muted mr-2 font-size-sm font-weight-bold"-->
        <!--                      >{{ item.text5 }}</span-->
        <!--                      >-->
        <!--                    <span class="text-muted font-size-sm font-weight-bold"-->
        <!--                    >Progress</span-->
        <!--                    >-->
        <!--                  </div>-->
        <!--                  <div class="progress progress-xs w-100">-->
        <!--                    <div-->
        <!--                        class="progress-bar"-->
        <!--                        role="progressbar"-->
        <!--                        :style="{ width: item.text5 }"-->
        <!--                        v-bind:class="`bg-${item.text6}`"-->
        <!--                        aria-valuenow="50"-->
        <!--                        aria-valuemin="0"-->
        <!--                        aria-valuemax="100"-->
        <!--                    ></div>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </td>-->
        <!--              <td class="pr-0 text-right">-->
        <!--                <a-->
        <!--                    href="#"-->
        <!--                    class="btn btn-icon btn-light btn-hover-primary btn-sm"-->
        <!--                >-->
        <!--                    <span class="svg-icon svg-icon-md svg-icon-primary">-->
        <!--                      &lt;!&ndash;begin::Svg Icon | path:assets/media/svg/icons/General/Settings-1.svg&ndash;&gt;-->
        <!--                      <inline-svg-->
        <!--                          src="media/svg/icons/General/Settings-1.svg"-->
        <!--                      />-->
        <!--                      &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                    </span>-->
        <!--                </a>-->
        <!--                <a-->
        <!--                    href="#"-->
        <!--                    class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"-->
        <!--                >-->
        <!--                    <span class="svg-icon svg-icon-md svg-icon-primary">-->
        <!--                      &lt;!&ndash;begin::Svg Icon | path:assets/media/svg/icons/Communication/Write.svg&ndash;&gt;-->
        <!--                      <inline-svg-->
        <!--                          src="media/svg/icons/Communication/Write.svg"-->
        <!--                      />-->
        <!--                      &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                    </span>-->
        <!--                </a>-->
        <!--                <a-->
        <!--                    href="#"-->
        <!--                    class="btn btn-icon btn-light btn-hover-primary btn-sm"-->
        <!--                >-->
        <!--                    <span class="svg-icon svg-icon-md svg-icon-primary">-->
        <!--                      &lt;!&ndash;begin::Svg Icon | path:assets/media/svg/icons/General/Trash.svg&ndash;&gt;-->
        <!--                      <inline-svg src="media/svg/icons/General/Trash.svg"/>-->
        <!--                      &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                    </span>-->
        <!--                </a>-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--          </template>-->
        <!--          </tbody>-->
        <!--        </table>-->
        <!--      </div>-->
        <!--      &lt;!&ndash;end::Table&ndash;&gt;-->
        <!--    </div>-->
        <!--    &lt;!&ndash;end::Body&ndash;&gt;-->
        <!--    &lt;!&ndash;end::Advance Table Widget 2&ndash;&gt;-->
    </div>
</template>

<script>
export default {
    name: "widget-2",
    data() {
        return {
            list: [
                {
                    text0: "media/svg/avatars/001-boy.svg",
                    text1: "Brad Simmons",
                    text2: "HTML, JS, ReactJS",
                    text3: "Intertico",
                    text4: "Web, UI/UX Design",
                    text5: "65%",
                    text6: "danger"
                },
                {
                    text0: "media/svg/avatars/018-girl-9.svg",
                    text1: "Jessie Clarcson",
                    text2: "C#, ASP.NET, MS SQL",
                    text3: "Agoda",
                    text4: "Houses & Hotels",
                    text5: "83%",
                    text6: "success"
                },
                {
                    text0: "media/svg/avatars/047-girl-25.svg",
                    text1: "Lebron Wayde",
                    text2: "PHP, Laravel, VueJS",
                    text3: "RoadGee",
                    text4: "Transportation",
                    text5: "47%",
                    text6: "primary"
                },
                {
                    text0: "media/svg/avatars/014-girl-7.svg",
                    text1: "Natali Trump",
                    text2: "Python, PostgreSQL, ReactJS",
                    text3: "The Hill",
                    text4: "Insurance",
                    text5: "71%",
                    text6: "danger"
                }
            ],
            checked: false
        };
    },
    components: {},
    methods: {
        setCheck(checked) {
            this.checked = checked;
        }
    }
};
</script>